import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getPartner } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import { deepEqual } from '../../utils';
import Config from '../../Components/Config';
import { getData } from '../../service/partnersData/actions';
import ExternalIdAssignation from '../../Components/ExternalDataAssignation';
import { Button, FormControlLabel, Switch } from '@material-ui/core';
import Alert from '../../../../Components/Alert';
import { patchVariable } from '../../../VariableServer/service/actions';

class Pongo extends Component {
	render() {
		const { partner, mask } = this.props;

		const activateWebview = e => {
			this.props.updateMaskOption(e.target.checked, mask ? mask.id : null);
			if (e.target.checked) {
				this.props.saveVariable({
					key: 'pongoDiscountId',
					value: 'loyalty-1',
				});
				this.props.initDiscountLoyalty();
			}
		};

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}>
					<FormControlLabel
						control={
							<Switch
								checked={mask && mask.active}
								onChange={activateWebview}
							/>
						}
						label={I18n.t('partner.pongo.enable_webview')}
					/>

					<Alert>{I18n.t('partner.pongo.webview_help')}</Alert>
				</div>
				<Config prefix_partner={partner.prefix || ''} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	const { user } = state.service;
	const mask = user.masks.find(m => m.mask_name === 'loyalty_pongo');

	return {
		partner,
		mask,
	};
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		updateMaskOption: (active, id) =>
			dispatch({
				type: 'UPDATE_MASK_OPTION',
				mask_name: 'loyalty_pongo',
				partner_prefix: props.prefix,
				active,
				id,
			}),
		saveVariable: data => dispatch(patchVariable(data)),
		initDiscountLoyalty: () =>
			dispatch({
				type: 'INIT_API_LOYALTY_DISCOUNT',
				prefix: 'pongo',
			}),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Pongo);
